import { AuthProvider as Provider } from 'hooks/useAuth';

const AuthProvider = ({ children, user }) => (
	<Provider user={user}>
		{children}
	</Provider>
);

export default AuthProvider;
